import { render, staticRenderFns } from "./HuaxianCreditModel.vue?vue&type=template&id=af424270&scoped=true&"
import script from "./HuaxianCreditModel.vue?vue&type=script&lang=js&"
export * from "./HuaxianCreditModel.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianCreditModel.vue?vue&type=style&index=0&id=af424270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af424270",
  null
  
)

export default component.exports